var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"margin-right-negative"},[(!_vm.isCurrency)?_c('span',[_vm._v(" ")]):_vm._e(),_vm._v(_vm._s(_vm.isCurrency ? _vm.getFlooredFixed(_vm.tweened) : _vm.tweened.toFixed(0))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }